import LoadingModal from '@components/atoms/modals/LoadingModal';
import InvestmentActivity from '@pages/portfolio/InvestmentActivity';
import { AnalyticsScreenName } from 'mh-client';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute';

const Names = AnalyticsScreenName.getInstance();

const Funds = lazy(() => import('@pages/funds/Funds'));
const DividendHistory = lazy(() => import('@pages/funds/DividendHistory'));

const FundLegalDocuments = lazy(
    () => import('@pages/funds/FundLegalDocuments')
);
// TODO #496: re-enable Holdings imports when commercial relationship returns
// const Holdings = lazy(() => import('@pages/holdings/Holdings'));
// const HoldingsDetails = lazy(() => import('@pages/holdings/HoldingsDetails'));
// const HoldingsLegalDocuments = lazy(
//     () => import('@pages/holdings/HoldingsLegalDocuments')
// );

export const FundRoutes = (
    <>
        <Route
            path="/funds"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <Funds />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.FUNDS_AND_HOLDINGS }}
        />
        <Route
            path="/funds/:ticker"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <Funds />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.FUNDS_AND_HOLDINGS }}
        />
        <Route
            path="/funds/:ticker/dividends/history"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <DividendHistory />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.DIVIDEND_HISTORY }}
        />
        <Route
            path="/funds/:ticker/investment"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <InvestmentActivity />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.INVESTMENT_ACTIVITY }}
        />

        <Route
            path="/funds/:ticker/documents"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <FundLegalDocuments />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.FUND_DOCUMENTS }}
        />
        {/* TODO #496: re-enable Holdings routes when commercial relationship returns */}
        {/* <Route
            path="/funds/:ticker/holdings"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <Holdings />
                        </Suspense>
                    }
                />
            }
        />
        <Route
            path="/funds/:ticker/holdings/:slug/details"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <HoldingsDetails />
                        </Suspense>
                    }
                />
            }
            // loader={HoldingsAPI.endpoints.getHoldingDetails.loader(store)}
        />

        <Route
            path="/funds/:ticker/holdings/:slug/documents"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <HoldingsLegalDocuments />
                        </Suspense>
                    }
                />
            }
        /> */}
    </>
);
